import { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";

const TransferListAside = ({
  title,
  items,
  field,
  selected,
  filterText,
  currentLimit,
  onFilterChange,
  onSelect,
}) => {
  const [filteredItems, setFilteredItems] = useState(items);

  const handleSearch = useCallback(() => {
    if (filterText?.length <= 2) return setFilteredItems(items);
    const filtered = items.filter((item) =>
      item[field].toLowerCase().startsWith(filterText.toLowerCase())
    );
    setFilteredItems([...filtered]);
  }, [items, filterText, field]);

  const getClassList = useCallback(
    (item) => {
      const classList = [];
      if (selected.includes(item[field])) classList.push("selected");
      else if (currentLimit < item?.weight) classList.push("disabled");
      return classList.join(" ");
    },
    [currentLimit, selected, field]
  );

  useEffect(() => handleSearch(), [handleSearch]);

  return (
    <div className="transfer-list-aside">
      {!!title && (
        <div className="transfer-list-aside_title">
          <p>{title}</p>
        </div>
      )}
      <div className="transfer-list-aside_filter">
        <input
          type="text"
          placeholder="Search"
          value={filterText}
          onChange={(e) => onFilterChange(e.target.value)}
        />
      </div>
      <div className="transfer-list-aside_item">
        <div className="transfer-list-aside_scroll">
          {filteredItems?.map((item, index) => (
            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
            <p
              onClick={() => onSelect(item[field])}
              onKeyUp={() => onSelect(item[field])}
              key={`item_${item[field]}_${index}`}
              className={getClassList(item)}
            >
              {item[field]}{" "}
              {item.weight
                ? (parseFloat(item.weight) * 100).toFixed(2) + "%"
                : ""}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};

TransferListAside.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  field: PropTypes.string.isRequired,
  selected: PropTypes.array.isRequired,
  filterText: PropTypes.string,
  currentLimit: PropTypes.number,
  onFilterChange: PropTypes.func,
  onSelect: PropTypes.func.isRequired,
};

export default TransferListAside;
